import { useEffect, useRef } from "react";
import { useInView, useMotionValue, animate } from "framer-motion";

const Counter = ({ value, suffix = "" }) => {
  const ref = useRef(null);
  const motionValue = useMotionValue(0);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      const controls = animate(motionValue, value, {
        duration: 2,
        ease: "easeOut",
        onUpdate(latest) {
          if (ref.current) {
            ref.current.textContent = Math.floor(latest) + suffix;
          }
        }
      });

      return () => controls.stop();
    }
  }, [isInView, value, suffix, motionValue]);

  return <span ref={ref}>0</span>;
};

export default Counter;